import {
  Component,
  OnDestroy,
  OnInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SESSION_STORAGE } from '~/auth/auth.module';

import { TitleService } from '~/core/services/title/title.service';
import { MessagingUserInterface } from '~/messaging/interfaces/user.interface';
import { MessagingService } from '~/messaging/services/messaging.service';
import { TalkService } from '~/messaging/services/talk.service';

@Component({
  selector: 'app-attendee-inbox',
  templateUrl: './inbox.component.html',
})
export class AttendeeInboxComponent implements OnInit, OnDestroy {
  public recipient: MessagingUserInterface | null | undefined;
  public isLoading = true;
  private readonly subscription = new Subscription();

  constructor(
    @Inject(SESSION_STORAGE) private readonly storage: Storage,
    @Inject(PLATFORM_ID) private readonly platformId: string,
    public readonly talkService: TalkService,
    private readonly titleService: TitleService,
    private readonly messagingService: MessagingService
  ) {}

  ngOnInit(): void {
    this.titleService.setPageTitle('seo.attendee.inbox.title');

    const sub = this.messagingService.recipientUpdated$.subscribe({
      next: (updated) => {
        if (updated === true) {
          this.recipient = JSON.parse(this.storage.getItem('talkjs-recipient'));
        }
        this.isLoading = false;
      },
    });

    this.subscription.add(sub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.messagingService.removeRecipient();
    this.messagingService.removeActivityData();
  }
}
